/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { EnrolmentQuestionnaireValues } from './enrolmentQuestionnaireModal-ng.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'enrolment-questionnaire-modal',
    standalone: false,
})
export class EnrolmentQuestionnaireModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<void>;
    @Input() resolve: EnrolmentQuestionnaireValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('enrolmentQuestionnaireModal', elementRef, injector);
    }
}
